import React, { useState, useEffect } from "react";
import { Grid2 as Grid, Stack } from '@mui/material';
import SearchBox from "../components/search_box";
import EarthquakeCard from "../components/earthquake_card";
import Pagination from "../components/pagination";
import { fetchData } from "../func/api";
import { BoxCenterStart } from '../style/box';
import { TypographyStepTitle } from '../style/typography';
import dayjs from 'dayjs';
import SkeletonLoading from "../components/skeleton_loading";
import { REPORT_STATUS } from "../const/config";


const EarthquakeList = () => {
  const [earthquakes, setEarthquakes] = useState([]);
  const [filteredEarthquakes, setFilteredEarthquakes] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const earthquakesPerPage = 5;
  const [loading, setLoading] = useState(true);
  const [refreshFlag, setRefreshFlag] = useState(false);
  
  const [filters, setFilters] = useState({
    name: '',
    status: [],
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    // 地震データと関連データを取得
    const getEarthquakes = async () => {
      try {
        const baseData = await fetchData("api/get_earthquake_list/");

        // 各地震に対して詳細データをまとめて取得
        const dataWithDetails = await Promise.all(
          baseData.map(async (eq) => {
            try {
              const [damDetailList] = await Promise.all([
                fetchData(`api/get_dam_report_detail_list/${eq.uuid}`)
              ]);

              return {
                ...eq,
                damReportDetailList: damDetailList
              };
            } catch (err) {
              console.error(`詳細データ取得失敗 (${eq.uuid}):`, err);
              return { ...eq, damReportDetailList: [] };
            }
          })
        );

        setEarthquakes(dataWithDetails);
        setFilteredEarthquakes(dataWithDetails);
      } catch (error) {
        console.error("地震データ取得中にエラー:", error);
      } finally {
        setLoading(false)
      }
    };
    getEarthquakes();
  }, [refreshFlag]);

  // フィルター処理
  const handleSearch = () => {
    const { name, status, startDate, endDate } = filters;

    const filtered = earthquakes.filter((eq) => {
      const occuredAt = dayjs(eq.occured_at);

      const statusName = (() => {
        if (eq.report_status_uuid === REPORT_STATUS.REPORTSTOP) return "途中終了";
        const damComplete = eq.report_status_uuid === REPORT_STATUS.SECONDARYCHECK && eq.report_powerplant_status_uuid === REPORT_STATUS.POWERPLANTCOMPLETE;
        if (damComplete) return "完了";

        return "対応中";
      })();

      const matchesName = eq.name.includes(filters.name);
      const matchesStatus = filters.status.length === 0 || filters.status.includes(statusName);
      const matchesDate =
        (!filters.startDate || occuredAt.isAfter(dayjs(filters.startDate).startOf("day"))) &&
        (!filters.endDate || occuredAt.isBefore(dayjs(filters.endDate).endOf("day")));

      return matchesName && matchesStatus && matchesDate;
    });

    setFilteredEarthquakes(filtered);
    setCurrentPage(1);
  };

  // ページネーション処理
  const indexOfLast = currentPage * earthquakesPerPage;
  const indexOfFirst = indexOfLast - earthquakesPerPage;
  const currentEarthquakes = filteredEarthquakes.slice(indexOfFirst, indexOfLast);

  if (loading) {
    return <SkeletonLoading />;
  }

  return (
    <BoxCenterStart>
      <Grid
        container
        spacing={1}
        columns={12}
        pt={12}
        pb={10}
        height={"100%"}
        width={{ xs: "90%", sm: "70%", md: "70%" }}
      >
        {/* 左側の検索ボックス */}
        <Grid size={{ xs: 12, sm: 3, md: 3 }} sx={{ backgroundColor: "grey.200" }}>
          <SearchBox filters={filters} setFilters={setFilters} onSearch={handleSearch} />
        </Grid>
        {/* 右側の地震一覧 */}
        <Grid size={{ xs: 12, sm: 9, md: 9 }}>
          <Stack spacing={1}>
            <TypographyStepTitle>地震一覧</TypographyStepTitle>
            {currentEarthquakes.map((eq) => (
              <EarthquakeCard key={eq.uuid} earthquake={eq} onDeleted={() => setRefreshFlag(flag => !flag)} />
            ))}
            {/* ページネーション用フッター */}
            <Pagination
              totalItems={filteredEarthquakes.length}
              itemsPerPage={earthquakesPerPage}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
            />
          </Stack>
        </Grid>
      </Grid>
    </BoxCenterStart>
  );
};

export default EarthquakeList;